import Link from "@components/core/Link";
import ProductImage from "@components/core/ProductImage";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import catalogContexts from "@utils/constants/catalogContexts";

const ProductImageLink = ({ algolia, product, onClick = () => {}, context, ...other }) => {
  const router = useRouter();

  const buildUrlPattern = () => {
    let productPathName = `/products/${product.slug}`;

    productPathName += `?algoliaQueryId=${algolia?.query_id}&algoliaIndexName=${algolia?.index_name}`;
    if (context === catalogContexts.sales) productPathName += `&context=${catalogContexts.sales}`;

    return productPathName;
  };

  function handleLinkClick(e) {
    e.preventDefault();

    onClick();
    router.push(buildUrlPattern());
  }

  return (
    <Link
      href={`/products/${product.slug}`}
      prefetch={false}
      onClick={handleLinkClick}
      data-testid="product-image-link"
      className="d-block w-100 h-100 position-relative"
      {...other}
    >
      <ProductImage
        src={product.main_picture_url}
        alt={product.name || ""}
        sizes="(max-width: 768px) 450px,
        (max-width: 1200px) 600px,
        450px"
      />
    </Link>
  );
};

export default ProductImageLink;
